import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import {
  FIELD_GROUP_CONSTANTS,
  INFO_GROUP_CONSTANTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import {
  FORM_VALIDATORS,
  LOCAL_STORAGE,
  PHONE_TRANSLATIONS
} from "@/shared/constants/FormConstants";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { PhonePayload } from "@/modules/InfoGroup/models/PhonePayload";
import { Schema } from "@/modules/FormTemplate/models/Schema";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { MODIF_VJSF_CONSTANTS } from "./constants/ModifVJsfInputConstants";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { PreventKey } from "@/shared/mixins/mixins";
import lodash from "lodash";
import { FormulaField } from "@/shared/models/FormulaField";
import { FormSchema } from "@/shared/models/FormSchema";

Vue.use(Vuetify);

@Component({
  name: "ModifVJsfInput",
  components: {
    VJsf,
    VuePhoneNumberInput
  }
})
export default class ModifVJsfInput extends PreventKey {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  @Prop({ default: () => ({}) }) value!: any;
  @Prop({ required: true }) schema!: GroupFullSchema;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  @Prop({ default: () => ({}) }) options!: any;
  @Prop({ default: () => [] }) phoneTypeList!: PhoneSchema[];
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any,@typescript-eslint/no-empty-function */
  @Prop({ default: () => () => {} }) debounce!: any;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  @Prop({ default: () => 1 }) vjsfKey!: any;
  @Prop({ default: () => [] }) customMessages!: { [key: string]: string };
  @Prop({ default: false }) viewIntelliticks!: boolean;
  @Prop({ default: true }) useDebounce!: boolean;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  PREFERRED_COUNTRIES = INFO_GROUP_CONSTANTS.PREFERRED_COUNTRIES;
  TRANSLATIONS = PHONE_TRANSLATIONS;

  defaultCountry = "";
  resetFields = 0;
  hasBeenCopied = false;
  beforeLocalModel: { [key: string]: any } = {};
  formulaField: undefined | FormulaField | string = undefined;
  multiselectFields: {
    [key: string]: number | string | number[] | string[];
  } = {};
  mounted() {
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
    for (const key in this.value) {
      if (Array.isArray(this.value[key])) {
        this.multiselectFields[key] = this.value[key];
      }
    }
  }

  isDisabledBySchema(): boolean {
    return !!this.schema.readOnly;
  }

  get localSchema() {
    const localSchema: GroupFullSchema = lodash.cloneDeep(this.schema);
    this.modifySchema(localSchema);
    return localSchema;
  }

  get localModel() {
    return this.value;
  }
  set localModel(newValue) {
    this.$emit(MODIF_VJSF_CONSTANTS.EVENT.INPUT, newValue);
  }

  @Watch("localModel")
  onRequiredComplete() {
    if (!this.useDebounce) {
      this.validateIfMustCallDebounceFunction();
      this.beforeLocalModel = lodash.cloneDeep(this.localModel);
    }
    if (!this.localSchema.allOf) {
      this.$emit(MODIF_VJSF_CONSTANTS.EVENT.ON_REQUIRED_COMPLETE, false);
      return;
    }
    if (this.localModel.length <= 0) {
      this.$emit(MODIF_VJSF_CONSTANTS.EVENT.ON_REQUIRED_COMPLETE, false);
      return;
    }
    const fieldsRequired: { field: string; pattern: string }[] = [];
    this.localSchema.allOf
      .map(item => {
        return {
          fields: item.required,
          properties: item.properties
        };
      })
      .forEach((item: any) => {
        item?.fields.forEach((field: string) => {
          fieldsRequired.push({
            field: field,
            pattern: item.properties[field].pattern
          });
        });
      });

    for (let index = 0; index < this.localSchema.allOf.length; index++) {
      const form = this.localSchema.allOf[index];
      const properties = Object.keys(form.properties);

      for (let index = 0; index < properties.length; index++) {
        const field = properties[index];
        let options: string[] | undefined;
        switch (form.properties[field]["x-display"]) {
          case FORM_TEMP_CONSTANTS.DISPLAY_TYPES.RADIO:
            options =
              form.properties[field].typeField ===
              FORM_TEMP_CONSTANTS.FIELD_TYPE.BASIC
                ? form.properties[field].enum
                : form.properties[field].oneOf?.map(e => e.const);
            break;
          case FORM_TEMP_CONSTANTS.DISPLAY_TYPES.CUSTOM_SELECT:
            options = form.properties[field].oneOf?.map(e => e.const);
            break;
          case MODIF_VJSF_CONSTANTS.CUSTOM_AUTOCOMPLETE:
            options = form.properties[field].oneOf?.map(e => e.const);
            break;
          case MODIF_VJSF_CONSTANTS.CUSTOM_STRING ||
            FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING:
            if (this.localModel[field]?.length > 90) {
              form.properties[field]["x-display"] =
                MODIF_VJSF_CONSTANTS.TEXT_AREA;
              form.properties[field]["readOnly"] = false;
            }
            break;
          case FIELD_GROUP_CONSTANTS.FIELD_TYPE.TEXTAREA:
            form.properties[field]["readOnly"] = false;
            break;
        }
        if (!this.localModel[field] && !this.hasBeenCopied) {
          this.localModel[field] = form.properties[field].value;
        }
        if (options && !options?.includes(this.localModel[field]))
          this.localModel[field] = undefined;
      }
    }

    const fieldsFilled = lodash.clone(this.localModel);

    const fieldsRequiredFilled = fieldsRequired.filter(e => {
      const reg = e.pattern ? new RegExp(e.pattern) : null;
      return (
        fieldsFilled[e.field] &&
        (typeof fieldsFilled[e.field] == FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
          ? fieldsFilled[e.field].trim() != ""
          : fieldsFilled[e.field] != "") &&
        (!reg || (reg && reg?.test(fieldsFilled[e.field])))
      );
    });
    if (
      fieldsRequiredFilled &&
      fieldsRequiredFilled.length == fieldsRequired.length
    ) {
      this.$emit(MODIF_VJSF_CONSTANTS.EVENT.ON_REQUIRED_COMPLETE, true);
      return;
    }
    this.$emit(MODIF_VJSF_CONSTANTS.EVENT.ON_REQUIRED_COMPLETE, false);
  }

  validateRequired(index: number): string {
    if (
      this.phoneTypeList[index].required == true &&
      !this.phoneTypeList[index].model
    ) {
      return MODIF_VJSF_CONSTANTS.TYPE.PHONE.COLOR.WARNING;
    } else {
      return MODIF_VJSF_CONSTANTS.TYPE.PHONE.COLOR.SUCCESS;
    }
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.phoneTypeList[index].countryCode = payload.countryCode;
    this.phoneTypeList[index].countryCallingCode = payload.countryCallingCode;
    this.phoneTypeList[index].isValid = payload.isValid;
    this.phoneTypeList[index].formattedNumber = payload.formattedNumber
      ? payload.formattedNumber
      : "";
  }

  modifySchema(schema: GroupFullSchema) {
    const arrSchema = schema.properties
      ? [schema.properties]
      : schema.allOf
          ?.map(g => {
            const properties = g.properties;
            const requiredItems = g.required || [];
            Object.keys(properties).map(key => {
              const element = properties[key];
              const isRequired = requiredItems.includes(key);
              if (isRequired) {
                if (
                  element["x-display"] ===
                  FIELD_GROUP_CONSTANTS.FIELD_TYPE.CHECKBOX
                ) {
                  element["minItems"] = 1;
                }
                if (!element.title.includes("*")) element.title += " *";
              }

              return element;
            });
            return properties;
          })
          .flat() ?? [{}];

    arrSchema.forEach(schema => {
      Object.entries(schema)
        .filter(
          (arrSchema: [string, Schema]) =>
            arrSchema[1]["x-display"] ==
              FIELD_GROUP_CONSTANTS.FIELD_TYPE.SLIDER ||
            arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.INTEGER ||
            arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER ||
            arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.EMAIL ||
            (arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING &&
              arrSchema[1]["format"] !=
                FIELD_GROUP_CONSTANTS.FIELD_FORMAT.DATE &&
              arrSchema[1]["x-display"] ==
                FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING) ||
            (arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING &&
              arrSchema[1]["x-display"] ==
                FIELD_GROUP_CONSTANTS.FIELD_TYPE.AUTOCOMPLETE) ||
            (arrSchema[1]["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING &&
              arrSchema[1]["x-display"] ==
                FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT)
        )
        .map((sliderSchema: [string, Schema]) => {
          const tempSchema: Schema = sliderSchema[1];
          if (
            tempSchema["x-display"] ==
              FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING &&
            (tempSchema["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.INTEGER ||
              tempSchema["type"] == FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER)
          ) {
            tempSchema["x-display"] = FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER;
          }
          tempSchema["x-display"] =
            MODIF_VJSF_CONSTANTS.PREFIX_NAME.CUSTOM + tempSchema["x-display"];
          if (
            (tempSchema.minimum ? tempSchema.minimum : 0) >
            (tempSchema.maximum ? tempSchema.maximum : 0)
          ) {
            const tmpMin = tempSchema.minimum;
            const tmpMax = tempSchema.maximum;
            tempSchema.minimum = tmpMax;
            tempSchema.maximum = tmpMin;
          }
          return tempSchema;
        });
    });
  }

  onUpdateModel(
    key: string,
    type: string,
    event: string,
    onAction: { input: (event?: string | number) => void }
  ) {
    this.hasBeenCopied = true;
    if (key) {
      if (event == "") {
        onAction.input(undefined);
        return;
      } else {
        if (
          type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING ||
          type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.EMAIL
        ) {
          onAction.input(event);
          return;
        }
        const newValue = Number(
          event.includes("e")
            ? event.split("e")[0]
            : event.substring(0, MODIF_VJSF_CONSTANTS.TYPE.NUMBER.MAX_LENGTH)
        );
        if (
          event.length >= MODIF_VJSF_CONSTANTS.TYPE.NUMBER.MAX_LENGTH ||
          event.includes("e")
        ) {
          this.resetFields = 1 - this.resetFields;
        }
        if (
          !isNaN(newValue) &&
          (!event.includes("e") || this.localModel[key] == undefined)
        ) {
          onAction.input(newValue);
          return;
        }
      }
    }
  }

  getRuleNumber(required: boolean): ((v: string) => string | true)[] {
    const numberRule = [FORM_VALIDATORS.NUMBER_FIELD];
    if (required) {
      numberRule.push(FORM_VALIDATORS.REQUIRED_FIELD);
    }
    return numberRule;
  }

  getRuleString(
    required: boolean,
    type: string
  ): ((v: string) => string | true)[] {
    if (!required) {
      return [];
    }
    const rules = [
      FORM_VALIDATORS.REQUIRED_FIELD,
      FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
    ];
    if (type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.EMAIL) {
      return [...rules, FORM_VALIDATORS.EMAIL_FIELD];
    }
    return rules;
  }
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  keydownEvent(event: any) {
    const validateAttr = Object.keys(event).includes(MODIF_VJSF_CONSTANTS.PATH);
    if (event && validateAttr && event.path.length > 0) {
      const input = event.path[0];
      if (input.type != FORM_TEMP_CONSTANTS.FIELD_TYPE.NUMBER) {
        return;
      }
    }
    if (event.key == "e" || event.key == "+") {
      event.preventDefault();
      return;
    }
  }

  getId(fullKey: string): string {
    return fullKey.replace(".", "-");
  }

  getThumbLabel(schema: GroupFullSchema) {
    return !schema["x-props"]
      ? false
      : schema["readOnly"] && schema["x-props"]["thumb-label"]
      ? "always"
      : schema["x-props"]["thumb-label"];
  }

  onBlurInputString(key: string) {
    this.$emit(MODIF_VJSF_CONSTANTS.EVENT.BLUR, key);
  }
  validatePhoneValid(index: number) {
    if (
      this.phoneTypeList[index].required ||
      (this.phoneTypeList[index].model && this.phoneTypeList[index].model != "")
    ) {
      return !this.phoneTypeList[index].isValid;
    }
    return false;
  }

  validateIfMustCallDebounceFunction() {
    if (this.formulaField === "") return;
    if (this.formulaField === undefined && (this.schema as FormSchema).fields) {
      const formulaFound = (this.schema as FormSchema).fields?.find(
        field => field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA
      );
      this.formulaField = formulaFound ? formulaFound.key : "";
    }

    if (!this.formulaField) return;
    for (const key in this.localModel) {
      if (key === (this.formulaField as FormulaField).key) continue;

      if (
        JSON.stringify(this.beforeLocalModel[key]) !==
        JSON.stringify(this.localModel[key])
      ) {
        this.debounce();
        break;
      }
    }
  }
}
